import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import useUser from 'hooks/useUser';
import UnauthorizedPage from 'components/layout/UnauthorizedPage';

import PostMessagesPage from './messages/PostMessagesPage';

const Admin: React.FC = () => {
  const { isBdataAmin } = useUser();

  if (!isBdataAmin) return <UnauthorizedPage />;

  return (
    <Routes>
      <Route index element={<Navigate to="messages" replace />} />
      <Route path="messages" element={<PostMessagesPage />} />
    </Routes>
  );
};

export default Admin;
